
import { Flight } from '@/types/flight';

interface SelectedFlightInfoProps {
  flight: Flight;
}

export function SelectedFlightInfo({ flight }: SelectedFlightInfoProps) {
  return (
    <div className="p-3 border rounded-md bg-muted/20">
      <p className="text-sm font-medium">Current Status: {flight.status}</p>
      <p className="text-xs text-muted-foreground">
        Departure: {new Date(flight.scheduled_departure).toLocaleString()}
      </p>
      <p className="text-xs text-muted-foreground">
        Arrival: {new Date(flight.scheduled_arrival).toLocaleString()}
      </p>
    </div>
  );
}
